import Programs from "pages/dashboard/shared/Programs/Programs";
import { FC } from "react";

interface AdminProgramsProps {}

const AdminPrograms: FC<AdminProgramsProps> = () => {
  return <Programs />;
};
export default AdminPrograms;
